import styled from "styled-components";

export const DetailContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-wrap: wrap;
`;

export const Text = styled.div`
    max-width: 400px;
    margin: 60px 20px;
    font-size: 1.5rem;
`;

export const Img = styled.img`
    margin: 40px 20px;
    border-radius: 15px;
`;

export const Genres = styled.p`
    font-size: 1rem;
    color: #00abb5;
`;

export const Title = styled.p`
    font-size: 3rem;
`;